import { init as initRelay } from "../init-relay";
import { ConfluenceTemplatesRelayPage } from "../pages/software/confluence/templates/confluence-templates-relay-page";
import {
    ConfluenceTemplatesUnifiedRelayPageQuery,
    getConfluenceTemplatesUnifiedRelayPageQueryVars
} from "../templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-templates-unified-relay-page.template";

initRelay(
    ConfluenceTemplatesRelayPage,
    ConfluenceTemplatesUnifiedRelayPageQuery,
    getConfluenceTemplatesUnifiedRelayPageQueryVars(window.location)
);
